<script setup lang="ts">
useSeoMeta({
  title: "Veranstaltungstechnik Flachau – Bühne, Ton & Licht mieten",
  ogTitle: "Veranstaltungstechnik Flachau – Bühne, Ton & Licht mieten | Mody",
  description: "Veranstaltungstechnik direkt in Flachau: Bühne, Beschallung & Licht vom lokalen Experten. Mody Veranstaltungstechnik – euer Partner vor Ort im Ennspongau.",
  ogDescription: "Veranstaltungstechnik direkt in Flachau: Bühne, Beschallung & Licht vom lokalen Experten. Mody Veranstaltungstechnik – euer Partner vor Ort im Ennspongau.",
})

const localBusinessJsonLd = {
  "@context": "https://schema.org",
  "@type": "LocalBusiness",
  "name": "Mody Veranstaltungstechnik",
  "url": "https://mody.at/veranstaltungstechnik-flachau",
  "telephone": "+43 664 2247433",
  "address": {
    "@type": "PostalAddress",
    "addressLocality": "Flachau",
    "postalCode": "5542",
    "addressRegion": "Salzburg",
    "addressCountry": "AT",
    "streetAddress": "Ennspark 193"
  },
  "areaServed": {
    "@type": "City",
    "name": "Flachau"
  },
  "description": "Veranstaltungstechnik direkt in Flachau – Bühne, Ton und Licht für Events jeder Größe."
}

useHead({
  script: [
    { type: 'application/ld+json', innerHTML: localBusinessJsonLd }
  ]
})

const offerings = [
  { icon: 'pi pi-volume-up', title: 'Beschallung', description: 'PA-Systeme für jede Größe – Selbstabholung aus Flachau möglich, Lieferung & Aufbau auf Wunsch.' },
  { icon: 'pi pi-sun', title: 'Lichttechnik', description: 'Stimmungsvolles Ambiente bis zur großen Lichtshow – für jeden Anlass das passende Lichtpaket.' },
  { icon: 'pi pi-home', title: 'Bühne', description: 'Unser StageTruck startet direkt in Flachau – schneller Aufbau, professionelles Ergebnis.' }
]

const events = ['Vereinsfeste', 'Brauchtumsfeste', 'Konzerte', 'Firmenfeiern', 'Hochzeiten', 'Après-Ski', 'Open-Air-Events', 'Geburtstagsfeiern', 'Straßenfeste']
const places = ['Flachau', 'Altenmarkt', 'Radstadt', 'Eben im Pongau', 'Wagrain', 'St. Johann im Pongau', 'Bischofshofen', 'Schladming']
</script>

<template>
  <LandingRegionalEventLanding
    kicker="Direkt vor Ort"
    title="Veranstaltungstechnik Flachau"
    hero-description="Unser Lager ist direkt in Flachau – kürzeste Wege, maximale Flexibilität, persönlicher Service für Events in der Region."
    intro-heading="Der lokale Experte für Veranstaltungstechnik in Flachau"
    :intro-paragraphs="[
      'Mody Veranstaltungstechnik hat seinen Sitz in Flachau, Ennspark 193. Kein anderer Anbieter kennt die lokalen Gegebenheiten, Venues und Besonderheiten der Region besser als wir. Seit über 25 Jahren begleiten wir Events in Flachau und Umgebung.',
      'Von der kleinen Vereinsfeier bis zur großen Open-Air-Veranstaltung – wir sind schnell vor Ort und sorgen dafür, dass alles reibungslos läuft.'
    ]"
    offerings-heading="Was wir in Flachau anbieten"
    :offerings="offerings"
    events-heading="Events, die wir in Flachau betreuen"
    :events="events"
    service-heading="Flachau und Umgebung"
    service-description="Von Flachau aus betreuen wir Events im gesamten Ennspongau und darüber hinaus."
    :places="places"
    cta-heading="Jetzt Angebot für euer Flachau-Event anfragen"
    cta-description="Kostenlos & unverbindlich. Wir melden uns schnell zurück mit einem individuellen Angebot."
  />
</template>
